import { FunctionComponent } from 'react';
import { ContainerProps } from './types';
import { Main } from './styles';

/**
 * A semantic wrapper component for the main content of the current page.
 */
const View: FunctionComponent<ContainerProps> = ({ contentType, ...props }) => (
  <Main className={`Main ${contentType}`} {...props} />
);

export default View;
